import { APP_LOCALES, LOCALE_META, type AppLocale } from '@/i18n/localeConfig';

/**
 * Root-relative URLs for SVG (and other static assets) served from `public/assets/icons/`.
 *
 * Convention:
 * - `public/assets/icons/masks/` — referenced from CSS (`mask-image`) or inline styles
 * - `public/assets/icons/ui/` — URL-based UI glyphs (`IconUiPaths`, e.g. `<img src={…}>`)
 * - `public/assets/images/flags/` — `FLAGS_IMAGES_ROOT` + `LocaleFlagPaths` (navbar / language UI;
 *   filenames mirror `i18n/localeConfig.ts`).
 *
 * For small UI glyphs that need `currentColor` or props, prefer `react-icons` (`./react`)
 * or add SVGR later and place sources under `assets/icons/svg/`.
 */
export const ICONS_PUBLIC_ROOT = '/assets/icons' as const;

/** Root-relative URLs for flag SVGs under `public/assets/images/flags/`. */
export const FLAGS_IMAGES_ROOT = '/assets/images/flags' as const;

/** App locale → flag asset */
export const LocaleFlagPaths = Object.fromEntries(
  APP_LOCALES.map((loc) => [
    loc,
    `${FLAGS_IMAGES_ROOT}/${LOCALE_META[loc].flagCode}.svg`,
  ]),
) as Record<AppLocale, string>;

export type LocaleFlagId = AppLocale;

export const IconMaskPaths = {
  circle: `${ICONS_PUBLIC_ROOT}/masks/circle-mask.svg`,
  rightArrow: `${ICONS_PUBLIC_ROOT}/masks/right-arrow-mask.svg`,
  speechBubble: `${ICONS_PUBLIC_ROOT}/masks/speech-bubble-mask.svg`,
  star: `${ICONS_PUBLIC_ROOT}/masks/star-mask.svg`,
  wavy: `${ICONS_PUBLIC_ROOT}/masks/wavy-mask.svg`,
} as const;

export type IconMaskId = keyof typeof IconMaskPaths;

export const IconUiPaths = {
  close: `${ICONS_PUBLIC_ROOT}/ui/close.svg`,
} as const;

export type IconUiId = keyof typeof IconUiPaths;
